import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-028bf765")

_pushScopeId("data-v-028bf765")
const _hoisted_1 = { class: "lg:container lg:mx-auto pt-8" }
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-y-8 gap-x-0 lg:gap-x-8" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "hidden lg:block" }, null, -1)
const _hoisted_4 = { class: "col-span-2 order-2 lg:order-1" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-y-8" }
const _hoisted_6 = { class: "px-1 lg:px-0" }
const _hoisted_7 = { style: {"background-color":"#ff4a8d","padding":"20px"} }
const _hoisted_8 = /*#__PURE__*/_createVNode("b", null, "Save me Jebus!", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createVNode("div", null, [
                  _createVNode("button", {
                    style: {"border":"1px solid black","margin-bottom":"20px"},
                    onclick: _ctx.approve100
                  }, " approve 100 ", 8, ["onclick"])
                ]),
                _createVNode("div", null, [
                  _createVNode("button", {
                    style: {"border":"1px solid black","margin-bottom":"20px"},
                    onclick: _ctx.enterFbeets
                  }, " enter with 100 ", 8, ["onclick"])
                ]),
                _createVNode("div", null, [
                  _createVNode("button", {
                    style: {"border":"1px solid black"},
                    onclick: _ctx.leaveFbeets
                  }, " leave with 100 ", 8, ["onclick"])
                ]),
                _hoisted_11,
                _createTextVNode(" Exchange rate: " + _toDisplayString(_ctx.currentExchangeRate) + " ", 1),
                _hoisted_12,
                _createTextVNode(" Exchange amount: " + _toDisplayString(_ctx.currentExchangeAmount) + " ", 1),
                _hoisted_13,
                _createTextVNode(" My fBeets balance: " + _toDisplayString(_ctx.currentFBeetsBalance), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
})